module.exports = __webpack_public_path__ + "assets/fcf4d859b4644ae6030a7d807a83de74.png";